import Headroom from "headroom.js";

export default class HeadroomController {
    constructor() {
        this.nav = document.querySelector(".js-navigation-bar");
        this.body = document.querySelector("body");

        if (this.nav) {
            this.init();
        }
    }

    init() {
        let headroom = new Headroom(this.nav, {
            classes: {
                notTop: "c-navigation--not-top",
                pinned: "c-navigation--pinned",
                top: "c-navigation--top",
                unpinned: "c-navigation--unpinned",
            },
            offset: window.innerHeight / 4,
            tolerance: 10,
        });

        headroom.init();
    }
}
